import { Displaying, Spacing } from "@bonusx-global/bx-design-system";
import { PREVIOUS_URL_PATH } from "../../../../../constants/env";
import { HeaderV2LayoutAction } from "../../../../../legacy/components/HeaderV2/stores/header-v2-layout-store";
import type { IHeaderV2Store } from "../../../../../legacy/components/HeaderV2/stores/header-v2-store";
import { headerHeight } from "../../../../../R";
import type { ILayoutStylesStore } from "../../../../../types/layout/layout-styles.type";
import type {
  IRouteWrapperGetVariant,
  IRouteWrapperVariant,
} from "../../../../../types/layout/route-wrapper-variant.interface";

export class SecondLevelWithTitleAndAiAssistantFullHeightRouteWrapperVariant implements IRouteWrapperVariant {
  get sidebarAvailable(): boolean {
    return true;
  }
  get headerAvailable(): boolean {
    return true;
  }
  get bottomNavigationAvailable(): boolean {
    return false;
  }

  get layoutStyles(): ILayoutStylesStore {
    return {
      contentLayoutStyles: {
        mobile: {
          display: Displaying.flex,
          minHeight: `calc(100vh - ${headerHeight})`,
          height: "100%",
          paddingBottom: `${Spacing["2500"]} !important`,
          "& > div#route-wrapper": {
            display: Displaying.flex,
            flex: 1,
            height: "auto",
          },
        },
      },
    };
  }

  get titleAvailable(): boolean {
    return true;
  }

  getVariantHeaderSettings({ title, defaultBackButtonUrl }: IRouteWrapperGetVariant): IHeaderV2Store {
    return {
      layoutStore: {
        backButton: {
          url: PREVIOUS_URL_PATH,
          defaultBackUrl: defaultBackButtonUrl,
        },
        actions: [HeaderV2LayoutAction.aiAssistant],
      },
      contentStore: {
        title,
      },
    };
  }
}
